import {isNullOrEmpty} from './strings.utils'
import {redondear2} from './calculo-dte'

export const roundToTwo = (num: number): string => {
  return redondear2(num).toFixed(2)
}

export const convertirNumeroConComas = (numString: string): string => {
  try {
    let num = ''
    let num2 = parseFloat(numString)

    if (isNaN(num2)) return numString

    num = num2.toLocaleString('en-US')

    if (num.includes('.')) {
      const decimales = num.split('.')
      if (decimales[1].length === 2) return num
      return `${num}0`
    }

    return `${num}.00`
  } catch (error) {
    return numString
  }
}
